import LaunchIcon from "@mui/icons-material/Launch";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import timezonePlugin from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

interface SessionGridRow {
	Id: number;
	Name: string;
	Date: string | Date;
}

/**
 * Returns an array of GridColDef for your “Sessions” table.
 *
 * @param handleNavigate  callback invoked when the Actions button is clicked
 * @param timezone        IANA-style timezone string (e.g. "Europe/Oslo")
 */
export function getSessionColumns<T extends SessionGridRow>(
	handleNavigate: (row: T) => void,
	timezone: string,
): GridColDef<T>[] {
	return [
		{ field: "Name", headerName: "Session Name", flex: 1 },
		{
			field: "Date",
			headerName: "Date",
			flex: 0.5,
			renderCell: (params) => {
				const raw = params.row.Date;
				const d = raw ? dayjs.utc(raw).tz(timezone || "UTC") : null;
				return (
					<Typography variant="caption">
						{d && d.isValid() ? d.format("DD/MM/YY") : "—"}
					</Typography>
				);
			},
		},
		{
			field: "Actions",
			headerName: "",
			sortable: false,
			filterable: false,
			flex: 0.2,
			renderCell: (params) => (
				<Tooltip title="View Details">
					<IconButton onClick={() => handleNavigate(params.row)}>
						<LaunchIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			),
		},
	];
}
